import React from 'react';
import { AboutItem } from '../../../../types/globalTypes';
import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../../../constants';
import { Text } from '../../../../components';
import { SHADOW } from '../../../../constants/animations';
import { MotionGridBlock } from '../../../../components/Motion';

interface AboutItemCardProps {
  item: AboutItem;
}

const AboutItemCard = ({ item }: AboutItemCardProps) => {
  return (
    <ItemWrapper>
      <Text
        text={item.title}
        fontFamily={FONTS.TITLE}
        size={35}
        lineHeight={35}
        color={COLORS.RED_TITLE}
      />
      <Text
        text={item.description}
        fontFamily={FONTS.SUBTITLE}
        size={18}
        lineHeight={27}
        color={COLORS.SECTION_TEXT}
      />
    </ItemWrapper>
  );
};
const ItemWrapper = styled(MotionGridBlock)`
  width: 210px;
  height: 210px;
  background-color: ${COLORS.GRAY_BG_COLOR};
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  &:hover {
    box-shadow: ${SHADOW.HOVER.CARD_WITH_NUMBER};
  }
  &:nth-child(2) {
    grid-column: 5;
  }
  &:nth-child(3) {
    grid-column: 6;
  }
  &:nth-child(4) {
    grid-column: 3 / span 1;
    grid-row: 2;
  }
  &:nth-child(5) {
    grid-column: 4 / span 1;
    grid-row: 2;
  }
  &:nth-child(6) {
    grid-column: 5 / span 1;
    grid-row: 2;
  }
  &:nth-child(7) {
    grid-column: 6 / span 1;
    grid-row: 2;
  }
  @media screen and ${device.xl} {
    width: 180px;
    height: 180px;
  }
  @media screen and ${device.lg} {
    &:nth-child(2) {
      grid-column: 3;
    }
    &:nth-child(3) {
      grid-column: 4;
    }
    &:nth-child(4) {
      grid-column: 1 / span 1;
      grid-row: 2;
    }
    &:nth-child(5) {
      grid-column: 2 / span 1;
      grid-row: 2;
    }
    &:nth-child(6) {
      grid-column: 3 / span 1;
      grid-row: 2;
    }
    &:nth-child(7) {
      grid-column: 4 / span 1;
      grid-row: 2;
    }
    gap: 20px;
  }
  @media screen and ${device.md} {
    width: 150px;
    height: 150px;
    padding: 5px;
    box-sizing: border-box;
    gap: 5px;
    > h4:first-child {
      font-size: 25px !important;
      line-height: 30px;
    }
    > h4:last-child {
      font-size: 18px !important;
      text-align: center;
      line-height: 24px;
    }
  }
  @media screen and ${device.bsm} {
    grid-column: auto !important;
    grid-row: auto !important;
    width: auto;
    height: auto;
    gap: 20px;
    aspect-ratio: 1;
  }
  @media screen and ${device.sm} {
    > h4:first-child {
      font-size: 22px !important;
      line-height: 26px;
    }
    > h4:last-child {
      font-size: 16px !important;
      text-align: center;
      line-height: 21px;
    }
    gap: 5px;
  }
  @media screen and ${device.xs} {
    > h4:first-child {
      font-size: 16px !important;
      line-height: 21px;
    }
    > h4:last-child {
      font-size: 13px !important;
      line-height: 17px;
    }
  }
`;
export default AboutItemCard;
